@if (isDocumentViewPage) {
  <div class="header-navigation-back">
    <mat-icon (click)="onNavigateBack()" data-test="back-arrow-icon">arrow_back</mat-icon>
    <span class="title">{{ heading }}</span>
  </div>
}

<div class="document-container" [class.embedded]="!isDocumentViewPage">
  <div class="error-message">{{ errorMessage }}</div>
  
  @if (!dqfDocumentId && !isDocumentViewPage && isCarrierUploadRequested) {
    <div class="carrier-upload-message">
      <span class="heading">Carrier upload requested</span>
      <span class="body padding-top-sm center">
        You will be able to view the document once the Carrier uploads.
      </span>
    </div>
  }

  <!-- Document Preview -->
  @if (previewImage || safeUrl) {
    <div
      class="document-preview"
      [class.is-pdf]="!!safeUrl"
      (wheel)="onPdfInteraction($event)"
      (touchmove)="onPdfInteraction($event)"
    >
      @if (previewImage) {
        <img [src]="previewImage" class="imagePreview" alt="Document preview" />
      }
      @if (safeUrl) {
        <iframe
          [src]="safeUrl"
          class="safeUrl"
          title="Document preview"
          frameborder="0"
          scrolling="yes"
        ></iframe>
      }
    </div>
  }

  <!-- Download Button - Now positioned below the document -->
  @if (isDocumentViewPage && (previewImage || safeUrl)) {
    <div class="download-section">
      <a mat-raised-button class="download-button" [href]="previewImage || safeUrl" target="_blank" download>
        <mat-icon>download</mat-icon>
        Download Document
      </a>
    </div>
  }
</div>
